import { Platform, type ViewStyle } from 'react-native';

/** Botones en web: sin outline/tap highlight que rompa el borde del card. */
export const WEB_BUTTON_FOCUS_RESET: ViewStyle | undefined =
  Platform.OS === 'web'
    ? ({
        outlineStyle: 'none',
        outlineWidth: 0,
        WebkitTapHighlightColor: 'transparent',
      } as unknown as ViewStyle)
    : undefined;
